export default "__VITE_ASSET__B$a1entv__"